import React from 'react';
import styled from 'styled-components';
import { capetalize } from "../../../../helpers"

class LocationContainer extends React.Component {
    render() {
        const { address, phone, url, subway } = this.props.data;
        return (
            <Container>
                <p><strong>Address: </strong>{address}</p>
                <p><strong>Nearest Metro: </strong>{capetalize(subway)}</p>
                <p><strong>Phone: </strong><a href={`tel:+${phone}`}>{phone}</a></p>
                <p><strong>Website: </strong><a href={url} rel="nofollow" target="_blank">{url}</a></p>
            </Container>
        )
    }
};

const Container = styled.div`
  background: #303030;
  color: #fff;
  display: inline-block;
  width: 100%;
  padding: 1rem;
  border-left: 4px solid #d64541;
  p {
    margin: 0;
    line-height: 1.5;
  }
  a {
    color: #fff;
    border-bottom: none;
  }
  strong {
    color: #fff;
  }
`;

export default LocationContainer;